import { MapObject } from "./map-object";

// http://www.randonneurs.ch/RandoV3/services/webcam/search?lon=8&lat=46&nb=2
export class Webcam extends MapObject {
    
    constructor(public id:number, public longitude:number, public latitude:number, public altitude:number, public azimuth:number,
        public label:String, public urlimage:String, public urltopic:String, public urlsource:String
    ) {
        super(id, longitude, latitude, label);
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/webcam.ts